import React, { memo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  dark?: boolean;
}

const TaskIcon = ({ dark = false, ...props }: Props) => {
  const { palette }: Theme = useTheme();
  const color = dark ? palette.secondary.lightest : palette.primary.main;
  return (
    <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-3.06 16L7.4 14.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L10.94 18zM13 9V3.5L18.5 9H13z"
        fill={color}
      />
    </SvgIcon>
  );
};

export default memo(TaskIcon);
